export default __webpack_public_path__ + "static/media/ndt-welds.28239eb8.jpg";